package com.example.mystybag.login.views

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalSoftwareKeyboardController
import androidx.compose.ui.platform.SoftwareKeyboardController
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.ui.components.custom.DefaultCircleShapedTextField
import com.example.mystybag.common.ui.components.native.DefaultButton
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.ui.views.BottomSheetUIView
import com.example.mystybag.core.defines.TextFieldType
import com.example.mystybag.core.expected.PlatformHelper
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p24
import com.example.mystybag.core.ui.theme.LocalTheme.p32
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.login.logic.MerchantForgotPasswordEmailViewModel
import com.example.mystybag.login.views.views.MerchantForgotPasswordEmailWebView
import dev.icerock.moko.resources.compose.stringResource

@Composable
fun MerchantForgotPasswordEmailView(viewModel: MerchantForgotPasswordEmailViewModel) {
    if (PlatformHelper.isWeb) {
        MerchantForgotPasswordEmailWebView(viewModel)
        return
    }

    val keyboardController = LocalSoftwareKeyboardController.current
    BottomSheetUIView(
        viewModel = viewModel,
        bottomSheetFactory = {}
    ) {
        MerchantForgotPasswordEmailForm(
            viewModel = viewModel,
            keyboardController = keyboardController,
            useScrollAndFixedButtonSpacing = false
        )
    }
}

@Composable
internal fun ColumnScope.MerchantForgotPasswordEmailForm(
    viewModel: MerchantForgotPasswordEmailViewModel,
    keyboardController: SoftwareKeyboardController?,
    useScrollAndFixedButtonSpacing: Boolean
) {
    val uiState by viewModel.uiState.subscribeAsState()
    val theme = AppTheme.current

    val columnModifier = if (useScrollAndFixedButtonSpacing) {
        Modifier
            .fillMaxWidth()
            .verticalScroll(rememberScrollState())
            .padding(horizontal = p16)
    } else {
        Modifier
            .fillMaxWidth()
            .weight(1f)
            .padding(horizontal = p16)
    }

    Column(
        modifier = columnModifier,
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .padding(top = p32, bottom = p24),
            contentAlignment = Alignment.CenterStart
        ) {
            Texts.DisplaySmall(
                text = stringResource(SR.strings.forgot_password),
                color = theme.colors.onSurface,
            )
        }

        DefaultCircleShapedTextField(
            modifier = Modifier.fillMaxWidth(),
            value = uiState.email,
            label = stringResource(SR.strings.email),
            errorText = uiState.emailErrorMsg,
            onValueChange = viewModel::onEmailChange,
            isError = uiState.emailIsError,
            inputType = TextFieldType.EMAIL,
            keyboardOptions = KeyboardOptions(
                keyboardType = KeyboardType.Email,
                imeAction = ImeAction.Done
            )
        )

        if (useScrollAndFixedButtonSpacing) {
            Spacer(modifier = Modifier.height(p32))
        } else {
            Spacer(Modifier.weight(1f))
        }

        DefaultButton(
            modifier = Modifier
                .fillMaxWidth()
                .padding(bottom = p8),
            caption = stringResource(SR.strings.continue_camel_case),
            callback = {
                keyboardController?.hide()
                viewModel.onContinue()
            },
            identifier = "Merchant Forgot Password Continue"
        )
    }
}
